/**
 * Navigation utility functions for optimized internal linking
 */

/**
 * Checks if a URL is an internal route (starts with /)
 */
export const isInternalLink = (href: string): boolean => {
  return href.startsWith('/') && !href.startsWith('//');
};

/**
 * Checks if a URL is a special protocol (mailto:, tel:, etc.)
 */
export const isSpecialProtocol = (href: string): boolean => {
  return /^(mailto:|tel:|sms:|fax:)/i.test(href);
};

/**
 * Gets the navigation handler for a link
 * Returns 'navigate' for internal links, 'window' for external/special links
 */
export const getNavigationHandler = (href: string): 'navigate' | 'window' => {
  if (isSpecialProtocol(href)) {
    return 'window'; // mailto:, tel: etc. need window.location
  }
  if (isInternalLink(href)) {
    return 'navigate'; // Internal routes use React Router
  }
  return 'window'; // External links use window.location
};

